import React from 'react';
import I18n from 'modules/i18n';
import { Program, SectionType } from '@/types/api/LessonOverview';
import videoActivityIcon from 'images/icons/video-activity-green-outline.svg';
import ButtonWithTooltip from '@/components/shared/LessonOverview/Cards/ActionBar/ButtonWithTooltip';
import Card, { ActionBar, CardBody } from './Card';
import AssignButton from './AssignButton';
import * as Routes from '../../../../modules/routes';
import Icon from '@/components/ui/Icon';

type SectionVideoCardProps = {
  lessonId: number;
  program: Program;
  readingPath: string;
  section: SectionType;
  stafferId?: number;
};

const SectionVideoCard = ({
  lessonId, program, readingPath, section, stafferId,
}: SectionVideoCardProps) => {
  const renderActionBar = () => (
    <ActionBar>
      <AssignButton
        className="tw-w-7 tw-h-7 tw-p-1.25 tw-flex tw-justify-center tw-items-center"
        iconSize={16}
        initialValues={{
          modelType: 'sectionNotebook',
          modelsToAssign: [section.assignable.value],
        }}
        isAssigned={section.isAssigned}
        lessonId={lessonId}
        program={program}
        stafferId={stafferId}
      />
      <ButtonWithTooltip
        openInNewWindow
        ariaLabel="Print reading"
        className="tw-box-border tw-flex tw-justify-center tw-items-center tw-w-7 tw-h-7"
        link={Routes.pdf_shared_program_lesson_path(program.id, lessonId, {
          locale: I18n.locale,
        })}
        tooltipContent={I18n.t('print_text')}
      >
        <Icon icon="Print" size={16} />
      </ButtonWithTooltip>
    </ActionBar>
  );

  return (
    <Card bannerBorderColor="green" label="video_activity" type={section.kind}>
      <CardBody
        ariaLabel={section.titleWithoutPageNumbers}
        iconSrc={videoActivityIcon}
        linkHref={readingPath}
        linkLabel={section.titleWithoutPageNumbers}
      >
        {I18n.t('lesson_video_description')}
      </CardBody>

      {stafferId && renderActionBar()}
    </Card>
  );
};

export default SectionVideoCard;
